const ErrorMsg = ({errTxt, isErr}) => {
    return isErr && <div className="form-err">{errTxt}</div>
}
export default ErrorMsg